/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-07 15:48:25
 * @LastEditors: caiqin.xie
 * @message: 博客列表右侧热门文章
 */
import React from "react";
import BlogItem from "../BlogItem";
import { IBlogItem } from '@/common/types'
import styles from "../../index.module.scss";

interface IProps {
  popularList: IBlogItem[]; // 热门文章
  ctry: string;
  words: Record<string, string>;
}

const PopularBlog = (props:IProps) => {
  const {popularList, ctry, words} = props
  return (
      <>
      { popularList && popularList.length > 0  &&
       <div className={styles['blog-right-center']}>
        <h3>{words?.blog_poplular_title}</h3>
        {/* Popular Posts */}
        <div className={styles['blog-right-list']}>
          {popularList && popularList.map((item, index) => (
            <a
              href={`/${ctry}/blog/${item.seoUrl}`}
              key={item.id}
              className={styles['link-blog']}>
              <BlogItem
                type='noContent'
                blogData={item}
                className={styles['custom-blog']}
                picClassName={styles['custom-blog-pic']}
                itemClassName={styles['custom-blog-item']} />
            </a>
          ))}
        </div>
      </div>
      }
      </>
  )
}
export default PopularBlog
